import PropTypes from "prop-types";
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
// routes
import { paths } from "src/routes/paths";
//
import { useAuthContext } from "../hooks";

// ----------------------------------------------------------------------

export default function AuthGuard({ children }) {
    // const { pathname, search } = useLocation();

    const { authenticated } = useAuthContext();

    // ----------------------------------

    // useEffect(() => {
    //     if (authenticated === null) return; // 避免状态未确定时执行
    //
    //     if (!authenticated) {
    //         localStorage.setItem("storedDestination", `${pathname}${search}`);
    //     }
    // }, [authenticated, pathname, search]);

    if (authenticated === false) {
        return <Navigate to={`${paths.auth.login}`} replace/>;
    }

    return children;
}

AuthGuard.propTypes = {
    children: PropTypes.node
};
